import { Module } from '../Module';

export interface IScheduleTypeNameFilter {
  (scheduleType: string): string;
}

Module.instance().filter('scheduleTypeName', [
  '$translate',
  ($translate: ng.translate.ITranslateService): IScheduleTypeNameFilter => {
    return (scheduleType: string) => $translate.instant(scheduleType.toLowerCase());
  }
]);
